export enum TaskPriority {
  LOW,
  NORMAL,
  HIGH,
  URGENT,
}
